/**
 * Community API 서비스
 * apiRequest 통합 버전
 */

import apiRequest from './api';

const COMMUNITY_API = '/api/community';

// ==================== 게시글 API ====================

/**
 * 게시글 목록 조회
 */
export const getPosts = async (board, page = 1, limit = 10) => {
  const params = new URLSearchParams({ board, page, limit });
  return apiRequest(`${COMMUNITY_API}/posts?${params}`);
};

/**
 * 게시글 상세 조회
 */
export const getPostById = async (postId) => {
  return apiRequest(`${COMMUNITY_API}/posts/${postId}`);
};

// Alias
export const getPost = getPostById;

/**
 * 게시글 작성
 */
export const createPost = async (board, title, content, category = null) => {
  return apiRequest(`${COMMUNITY_API}/posts`, {
    method: 'POST',
    body: JSON.stringify({ board, title, content, category })
  });
};

/**
 * 게시글 수정
 */
export const updatePost = async (postId, title, content) => {
  return apiRequest(`${COMMUNITY_API}/posts/${postId}`, {
    method: 'PUT',
    body: JSON.stringify({ title, content })
  });
};

/**
 * 게시글 삭제
 */
export const deletePost = async (postId) => {
  return apiRequest(`${COMMUNITY_API}/posts/${postId}`, {
    method: 'DELETE'
  });
};

// ==================== 댓글 API ====================

/**
 * 댓글 조회 (게시글 상세에서 가져옴)
 */
export const getComments = async (postId) => {
  const result = await apiRequest(`${COMMUNITY_API}/posts/${postId}`);
  return result.data?.comments || [];
};

/**
 * 댓글 작성
 */
export const createComment = async (postId, content, parentId = null) => {
  return apiRequest(`${COMMUNITY_API}/posts/${postId}/comments`, {
    method: 'POST',
    body: JSON.stringify({ content, parent_id: parentId })
  });
};

/**
 * 댓글 삭제
 */
export const deleteComment = async (commentId) => {
  return apiRequest(`${COMMUNITY_API}/comments/${commentId}`, {
    method: 'DELETE'
  });
};

// ==================== 신고 API ====================

/**
 * 게시글 신고
 */
export const reportPost = async (postId, reason) => {
  return apiRequest(`${COMMUNITY_API}/posts/${postId}/report`, {
    method: 'POST',
    body: JSON.stringify({ target_type: 'post', reason })
  });
};

/**
 * 댓글 신고
 */
export const reportComment = async (commentId, reason) => {
  return apiRequest(`${COMMUNITY_API}/posts/${commentId}/report`, {
    method: 'POST',
    body: JSON.stringify({ target_type: 'comment', reason })
  });
};

/**
 * 신고 목록 조회 (관리자)
 */
export const getReports = async (status = null) => {
  const params = status ? `?status=${status}` : '';
  return apiRequest(`${COMMUNITY_API}/reports${params}`);
};

/**
 * 신고 상태 변경 (관리자)
 */
export const updateReportStatus = async (reportId, status) => {
  return apiRequest(`${COMMUNITY_API}/reports/${reportId}`, {
    method: 'PUT',
    body: JSON.stringify({ status })
  });
};

// Alias
export const handleReport = updateReportStatus;

// ==================== 관리자 API ====================

/**
 * 게시글 숨김 (관리자)
 */
export const hidePost = async (postId) => {
  return apiRequest(`${COMMUNITY_API}/posts/${postId}/hide`, {
    method: 'PUT'
  });
};

/**
 * 댓글 숨김 (관리자)
 */
export const hideComment = async (commentId) => {
  return apiRequest(`${COMMUNITY_API}/comments/${commentId}/hide`, {
    method: 'PUT'
  });
};
